<div class="form-container">
    <div class="form-field">
        <label for="fechaDesde" class="labelTitle">1. {{ 'PREVIEW_SPACE.DATE_FROM_SELECT' | translate }}</label>
        <input id="fechaDesde" type="date" data-date-format="YYYY-MM-DD" [(ngModel)]="specificData.fechaDesde" (change)="emitValueChange(specificData)">
    </div>
    <div class="form-field">
        <label for="fechaHasta" class="labelTitle">2. {{ 'PREVIEW_SPACE.DATE_TO_SELECT' | translate }}</label>
        <input id="fechaHasta" type="date" data-date-format="YYYY-MM-DD" [(ngModel)]="specificData.fechaHasta" (change)="emitValueChange(specificData)">
    </div>
</div>